<template>
    <div class="titulo">
        <div class="margem container">
            <div class="m-icone esquerda"><a @click="this.$router.back()" style="cursor: pointer;"
                    class="icone-voltar m-d"></a></div>
            <TituloProjetoAntecessor v-if="idProjeto !== 'criar'" :projeto-id="idProjeto" :nome="projeto.nome || ''"
                :codigo="pcm.codigo || ''" :nome-origem="projetoOrigem.nome" :codigo-origem="projetoOrigem.codigo"
                :visualizando="!!vendoAntecessorId" :antecessor-aberto-id="vendoAntecessorId"
                :pode-editar="podeEditarAntecessor" @selecionar="abrirAntecessor" @voltar="voltarProjetoAtual" />
            <h2 v-else>Novo Projeto</h2>
            <span v-if="projetoConcluido" class="chip bg-sucesso projeto-concluido-badge"> {{ projetoSomenteLeitura ?
                'Projeto concluído — somente leitura' : 'Projeto concluído' }} </span>
        </div>
    </div>
    <div class="margem">
        <div>
            <div class="abas">
                <a v-for="a, index in abasVisiveis" :key="index"
                    @click="(idProjeto == 'criar' && a.id !== 1) ? null : (aba = a.id)"
                    :class="[{ 'ativo': aba == a.id }, { 'disabled': (idProjeto == 'criar' && a.id != 1) }]"> {{ a.nome
                    }} </a>
            </div>
        </div>
        <div class="bloco" :class="{ 'margem': aba !== 1 && aba !== 10, 'bloco--pcm': aba === 1 || aba === 10 }"
            v-if="projeto.id && !loading">
            <PortfolioProjetoDetalheAuditor v-if="aba == 10 && projeto.id !== 'criar'" :id="projeto.id" embedded />
            <PcmComponent v-if="aba == 1" :propPCM="pcm" @getProjeto="getProjeto" :isGerente="isGerente"
                :somente-leitura="projetoSomenteLeitura" :ai-form-state="aiFormState"
                @ai-field-edited="markAiFieldManual" @rascunho-restaurado="onRascunhoRestaurado" />
            <ReuniãoAprovação v-if="aba == 2" :propPCM="pcm" :projeto="projeto" @getProjeto="getProjeto"
                :somente-leitura="projetoSomenteLeitura" :is-gerente-projeto="isGerente" :is-auditor="isAuditor" />
            <SprintsView ref="sprintsView" v-if="aba == 3 && projeto.id" :propProjeto="projeto" :propPcm="pcm" :isGerente="isGerente"
                :isPO="isPO" :isAuditor="isAuditor" :somente-leitura="projetoSomenteLeitura" @getProjeto="getProjeto"
                :destaque-entrega-id="$route.query.entrega_id" :destaque-sprint-id="$route.query.sprint_id"
                :destaque-tarefa-id="$route.query.destaque_tarefa_id"
                @entrega-selecionada="entregaAtivaParaDemandaId = $event" />
            <AnexosProjetoTab v-if="aba == 8" :anexos="anexosProjeto" :storage-url="storageUrl"
                :anexando="anexandoAnexo" :excluindo-anexo-id="excluindoAnexoId"
                :somente-leitura="projetoSomenteLeitura" @adicionar="adicionarAnexoProjeto"
                @excluir="excluirAnexoProjeto" />
            <ReunioesProjetoTab v-if="aba == 9" :projeto="projeto" :somente-leitura="projetoSomenteLeitura" />
            <OrcamentoComponent v-if="aba == 4" :propPCM="pcm" :projetoId="projeto.id"
                :setores="setoresUsuarios.setores" :podeVerOrcamento="podeVerOrcamento"
                :propReadOnly="projetoSomenteLeitura" :is-gerente="isGerente" :is-auditor="isAuditor"
                @demandas-bloqueadas-change="projeto.demandas_bloqueadas = $event" />
            <EncerramentoProjeto v-if="aba == 5" v-model="existePedidoEncerramento" :propProjetoID="projeto.id"
                :podeVerOrcamento="podeVerOrcamento" :propEstimativaCusto="custoPrevistoPcm"
                :entregas="entregasProjeto" :somente-leitura="projetoSomenteLeitura" />
            <GestãoDeAcessoComponent v-if="aba == 6" :propProjeto="projeto" :is-auditor="isAuditor"
                :somente-leitura="projetoSomenteLeitura" @getProjeto="getProjeto" />
            <ProdutosView v-if="aba == 7" :propProjeto="projeto" :propProdutos="produtos"
                :carregando-produtos="produtosCarregando" :somente-leitura="projetoSomenteLeitura"
                @getProjeto="getProjeto" />
            <LogsProjeto v-if="aba == 11 && podeVerLogsProjeto" :projeto-id="projeto.id" embedded />
        </div>
        <div class="bloco margem" v-else>
            <div class="loading">
                <div></div>
            </div>
        </div>
        <ChamarDemandaProjeto v-if="aba === 3 && projeto.id != 'criar' && !projetoSomenteLeitura" :propSigla="'PRJ'"
            :propId="projeto.id" :entrega-projeto-id="entregaAtivaParaDemandaId"
            :demandas-bloqueadas="!!projeto.demandas_bloqueadas || projeto.status !== 'Em andamento'" />
    </div>
</template>
<script>
import SprintsView from "@/components/Projetos/Sprints/SprintsView.vue";
import PcmComponent from "@/components/PCM/pcmComponent.vue";
import OrcamentoComponent from "@/components/Projetos/OrcamentoComponent.vue";
import ReuniãoAprovação from "@/components/Projetos/ReuniãoAprovação.vue";
import serviceProjetos from "@/services/serviceProjetos";
import GestãoDeAcessoComponent from "@/components/Projetos/GestãoDeAcessoComponent.vue";
import EncerramentoProjeto from "@/components/Projetos/EncerramentoProjeto.vue";
import { sso } from "roboflex-thalamus-sso-lib";
import { getPermissao } from '@/services/permissao-service';
import servicePCM from "@/services/servicePCM";
import { consultarSetores } from "@/services/usuario-setor";
import ChamarDemandaProjeto from "@/components/Projetos/ChamarDemandaProjeto.vue";
import ProdutosView from "@/components/Projetos/ProdutosView.vue";
import { urlFoto } from "@/services/api";
import AnexosProjetoTab from "@/components/Projetos/AnexosProjetoTab.vue";
import ReunioesProjetoTab from "@/components/Projetos/ReunioesProjetoTab.vue";
import PortfolioProjetoDetalheAuditor from "@/views/Gestão/PortfolioProjetoDetalheAuditor.vue";
import LogsProjeto from "@/views/Gestão/LogsProjeto.vue";
import TituloProjetoAntecessor from "@/components/Projetos/TituloProjetoAntecessor.vue";
import {
    definirContextoAntecessor,
} from "@/utils/projeto-antecessor.context";
import {
    ABA_VISAO_GERAL,
    abaInicialProjeto,
    podeVerVisaoGeral,
} from "@/utils/portfolio-notas";
import { podeVerLogsProjeto } from "@/utils/projeto-logs.access";
import { useAiAssistantContext } from "@/composables/useAiAssistantContext";
import {
    applyAssistantPatches,
    confirmAiFields,
    createAssistantFormState,
    initializeManualOwnership,
    markFieldManual,
    sanitizeProjectContext,
} from "@/utils/ai-assistant.state";


export default {
    setup() {
        const { registerPageContext } = useAiAssistantContext()
        return {
            registerPageContext,
            aiFormState: createAssistantFormState(),
        }
    },
    components: {
        SprintsView,
        PcmComponent,
        OrcamentoComponent,
        ReuniãoAprovação,
        GestãoDeAcessoComponent,
        EncerramentoProjeto,
        ChamarDemandaProjeto,
        ProdutosView,
        AnexosProjetoTab,
        ReunioesProjetoTab,
        PortfolioProjetoDetalheAuditor,
        LogsProjeto,
        TituloProjetoAntecessor,
    },

    props: {
        idProjeto: {
            required: true,
        },
    },

    computed: {
        isGerente() {
            return (this.projeto.gerente_id == this.idUsuario || this.pcm.gerentePCM_id == this.idUsuario) || this.projeto.assessor_id == this.idUsuario
        },
        isPO() {
            return this.projeto.product_owner_id == this.idUsuario
        },
        isAuditor() {
            return this.funcionalidadeUsuario.includes(116)
        },
        podeVerOrcamento() {
            return this.isGerente || this.isAuditor || (this.pcm?.comite_aprovacao && Array.isArray(this.pcm.comite_aprovacao) && this.pcm.comite_aprovacao.map(i => i.id).includes(this.idUsuario))
        },
        custoPrevistoPcm() {
            const resultados = Array.isArray(this.pcm?.resultados) ? this.pcm.resultados : []
            return resultados.reduce((acc, res) => {
                if (res?.sem_custo) return acc
                const n = Number(res?.custo)
                return acc + (Number.isFinite(n) ? n : 0)
            }, 0)
        },
        podeVerVisaoGeral() {
            return podeVerVisaoGeral({
                isCriar: this.idProjeto === 'criar',
                isAuditor: this.isAuditor,
                userId: this.idUsuario,
                projeto: this.projeto,
                pcm: this.pcm,
            })
        },
        podeVerLogsProjeto() {
            return podeVerLogsProjeto({
                isAuditor: this.isAuditor,
                userId: this.idUsuario,
                projeto: this.projeto,
                pcm: this.pcm,
            })
        },
        abasVisiveis() {
            return this.abas.filter((a) => {
                if (a.id === ABA_VISAO_GERAL) return this.podeVerVisaoGeral
                if (a.id === 11) return this.podeVerLogsProjeto
                return true
            })
        },
        projetoConcluido() {
            return this.projeto?.status === 'Concluído'
        },
        projetoSomenteLeitura() {
            if (this.vendoAntecessorId && !this.podeEditarAntecessor) return true
            // Auditores podem editar projetos concluídos
            return this.projetoConcluido && !this.isAuditor
        },
    },

    data() {
        return {
            aba: null,
            abas: [
                { id: ABA_VISAO_GERAL, nome: 'Visão Geral' },
                { id: 1, nome: 'Proposta de Projeto' },
                { id: 2, nome: 'Reunião de Aprovação' },
                { id: 3, nome: 'Plano de Projeto' },
                { id: 8, nome: 'Anexos' },
                { id: 4, nome: 'Demandas' },
                { id: 7, nome: 'Produtos' },
                { id: 6, nome: 'Gestão de Acesso' },
                { id: 9, nome: 'Reuniões' },
                { id: 11, nome: 'Logs' },
            ],
            projeto: {},
            pcm: {},
            idUsuario: null,
            funcionalidadeUsuario: [],
            loading: true,
            setoresUsuarios: [],
            produtos: [],
            produtosCarregando: true,
            anexosProjeto: [],
            storageUrl: urlFoto.caminhoFoto,
            anexandoAnexo: false,
            excluindoAnexoId: null,
            entregaAtivaParaDemandaId: null,
            existePedidoEncerramento: false,
            entregasProjeto: [],
            projectWorkContextRevision: 0,
            abaInicialDefinida: false,
            vendoAntecessorId: null,
            podeEditarAntecessor: false,
            projetoOrigem: { nome: '', codigo: '' },
        }
    },
    created() {
        const abaQuery = Number(this.$route.query.aba)
        this.aba = this.idProjeto == 'criar' ? 1 : (abaQuery || null)
        const usuarioLogado = sso.getUsuarioLogado()
        this.idUsuario = usuarioLogado.id
        serviceProjetos.instalarContextoAntecessor()
        this.registerAiPageContext()
    },
    watch: {
        idProjeto() {
            this.projectWorkContextRevision = 0
            this.abaInicialDefinida = false
            this.vendoAntecessorId = null
            this.podeEditarAntecessor = false
            this.projetoOrigem = { nome: '', codigo: '' }
            definirContextoAntecessor(null, null)
            this.aiFormState = createAssistantFormState()
            this.registerAiPageContext()
            this.getProjeto()
        },
        aba() {
            this.registerAiPageContext()
        },
    },
    beforeUnmount() {
        this.unregisterAiContext?.()
        definirContextoAntecessor(null, null)
    },
    async mounted() {
        this.funcionalidadeUsuario = await getPermissao();
        this.getProjeto();
        this.setoresUsuarios = await consultarSetores();
        this.getProdutos();
    },
    methods: {
        registerAiPageContext() {
            this.unregisterAiContext?.()
            const idEmTela = this.vendoAntecessorId || this.idProjeto
            const leituraAntecessor = !!this.vendoAntecessorId && !this.podeEditarAntecessor
            if (this.idProjeto !== 'criar' && this.aba === 3 && !leituraAntecessor) {
                this.unregisterAiContext = this.registerPageContext({
                    module: 'projects',
                    route: this.$route.path,
                    entityType: 'project',
                    entityId: Number(idEmTela),
                    mode: 'edit',
                    capabilities: ['project_work'],
                    pageIdentity: `projects:project-work:${idEmTela}`,
                    refreshWork: () => this.$refs.sprintsView?.getEntregas?.(),
                    getContext: () => {
                        const pcmId = Number(this.pcm?.id)
                        return {
                            project_id: Number(idEmTela),
                            pcm_id: Number.isFinite(pcmId) ? pcmId : null,
                            context_revision: this.projectWorkContextRevision,
                            form_state: {},
                            ui_context: {
                                active_tab: 'Plano de Projeto',
                                project_code: this.pcm?.codigo || null,
                                project_name: this.projeto?.nome || null,
                                project_status: this.projeto?.status || null,
                                pcm_status: this.pcm?.status || null,
                                read_only: this.projetoSomenteLeitura,
                                roles: {
                                    manager: this.isGerente,
                                    auditor: this.isAuditor,
                                    product_owner: this.isPO,
                                },
                                ...(this.$refs.sprintsView?.assistantContext?.() || {}),
                            },
                        }
                    },
                })
                return
            }
            this.unregisterAiContext = this.registerPageContext({
                module: 'projects',
                route: this.$route.path,
                entityType: this.idProjeto === 'criar' ? null : 'project',
                entityId: this.idProjeto === 'criar' ? null : Number(idEmTela),
                mode: this.idProjeto === 'criar' ? 'create' : 'view',
                capabilities: this.idProjeto === 'criar' ? ['project_create'] : [],
                pageIdentity: `projects:project:${idEmTela}`,
                getContext: () => ({
                    ...sanitizeProjectContext(this.pcm, this.aiFormState),
                    ui_context: {
                        active_tab: this.abas.find((item) => item.id === this.aba)?.nome || null,
                        project_code: this.pcm?.codigo || null,
                        project_name: this.projeto?.nome || null,
                        project_status: this.projeto?.status || null,
                        pcm_status: this.pcm?.status || null,
                        read_only: this.projetoSomenteLeitura,
                        roles: {
                            manager: this.isGerente,
                            auditor: this.isAuditor,
                            product_owner: this.isPO,
                        },
                    },
                }),
                ...(this.idProjeto === 'criar' ? {
                    applyPatches: (patches) => applyAssistantPatches(this.pcm, this.aiFormState, patches),
                    confirmSuggestions: () => confirmAiFields(this.aiFormState),
                } : {}),
            })
        },
        markAiFieldManual(fieldPath) {
            markFieldManual(this.aiFormState, fieldPath)
        },
        /**
         * Rascunho local restaurado no formulário de criação: tudo que voltou passa a ser
         * propriedade do usuário (manual). Avançamos a revisão para que sugestões da IA
         * calculadas sobre o estado anterior fiquem obsoletas e não sobrescrevam o rascunho.
         */
        onRascunhoRestaurado() {
            const revisaoAtual = Number(this.aiFormState?.contextRevision || 0)
            this.aiFormState = createAssistantFormState()
            this.aiFormState.contextRevision = revisaoAtual + 1
            initializeManualOwnership(this.aiFormState, this.pcm)
        },
        aplicarAbaInicial() {
            if (this.abaInicialDefinida) return
            const abaInicial = abaInicialProjeto({
                isCriar: this.idProjeto === 'criar',
                queryAba: this.$route.query.aba,
                visaoGeral: this.podeVerVisaoGeral,
            })
            this.aba = abaInicial === 11 && !this.podeVerLogsProjeto ? 3 : abaInicial
            this.abaInicialDefinida = true
        },
        async getProdutos() {
            this.produtosCarregando = true;
            try {
                this.produtos = await serviceProjetos.getProdutos();
            } finally {
                this.produtosCarregando = false;
            }
        },
        async getProjeto(id) {
            if (this.idProjeto == 'criar' && !id) {
                this.pcm.id = 'criar'
                this.pcm.tipo = 'Projeto';
                this.projeto.nome = 'Novo Projeto'
                this.projeto.id = 'criar';
                initializeManualOwnership(this.aiFormState, this.pcm)
                this.loading = false
                this.aplicarAbaInicial()
            } else {
                if (!id) {
                    id = this.vendoAntecessorId || this.idProjeto;
                }
                var response = await serviceProjetos.getProjetoById(id)
                this.projeto = response
                if (!this.vendoAntecessorId) {
                    this.projetoOrigem = {
                        nome: response.nome || '',
                        codigo: response.pcm_codigo || '',
                    }
                }
                this.projectWorkContextRevision += 1
                await this.carregarAnexosProjeto()
                if (response.pcm_associado[0]?.id) {
                    this.getPcm(response.pcm_associado[0]?.pcm_id)
                } else {
                    this.loading = false
                    this.aplicarAbaInicial()
                    this.registerAiPageContext()
                }
            }
        },

        async abrirAntecessor(item) {
            this.vendoAntecessorId = item.id
            this.podeEditarAntecessor = item.pode_editar === true
            definirContextoAntecessor(this.idProjeto, item.id)
            this.loading = true
            this.entregaAtivaParaDemandaId = null
            this.aiFormState = createAssistantFormState()
            try {
                await this.getProjeto(item.id)
            } catch {
                this.loading = false
            }
        },

        async voltarProjetoAtual() {
            this.vendoAntecessorId = null
            this.podeEditarAntecessor = false
            definirContextoAntecessor(null, null)
            this.loading = true
            this.entregaAtivaParaDemandaId = null
            this.aiFormState = createAssistantFormState()
            try {
                await this.getProjeto(this.idProjeto)
            } catch {
                this.loading = false
            }
        },

        async getPcm(id) {
            this.pcm = await servicePCM.getPCM(id);
            this.projectWorkContextRevision += 1
            for (const key in this.pcm) {
                const valor = this.pcm[key]

                // verifica se é string e parece uma data
                if (typeof valor === 'string' && !isNaN(Date.parse(valor))) {
                    // corta tudo após o 'T' ou espaço
                    this.pcm[key] = valor.split('T')[0].split(' ')[0]
                }
            }
            initializeManualOwnership(this.aiFormState, this.pcm)
            if (!this.vendoAntecessorId && this.pcm?.codigo) {
                this.projetoOrigem = {
                    nome: this.projetoOrigem.nome || this.projeto.nome || '',
                    codigo: this.pcm.codigo,
                }
            }
            this.loading = false
            this.aplicarAbaInicial()
            this.registerAiPageContext()
        },
        async carregarAnexosProjeto() {
            if (!this.projeto?.id || this.projeto.id === 'criar') {
                this.anexosProjeto = []
                return
            }
            const response = await serviceProjetos.getEntregas(this.projeto.id)
            this.anexosProjeto = response?.anexosProjeto || []
            this.entregasProjeto = response?.projetos?.[0]?.entregas ?? []
        },
        async excluirAnexoProjeto(idAnexo) {
            if (this.projetoSomenteLeitura) return
            this.excluindoAnexoId = idAnexo
            try {
                await serviceProjetos.excluiAnexoProjeto(idAnexo)
                this.anexosProjeto = this.anexosProjeto.filter((a) => a.id !== idAnexo)
            } finally {
                this.excluindoAnexoId = null
            }
        },
        async adicionarAnexoProjeto(files) {
            if (this.projetoSomenteLeitura) return
            if (!files?.length || !this.projeto?.id) return

            this.anexandoAnexo = true
            try {
                const formData = new FormData()
                formData.append('projeto_id', this.projeto.id)
                for (let i = 0; i < files.length; i++) {
                    formData.append('anexos[]', files[i])
                }

                const response = await serviceProjetos.adicionarAnexoProjeto(formData)
                const anexosSalvos = response?.data?.anexos_salvos || []
                anexosSalvos.forEach((item) => {
                    this.anexosProjeto.push({
                        id: item.id,
                        nome: item.nome,
                        path: item.path,
                    })
                })
            } finally {
                this.anexandoAnexo = false
            }
        }
    }
}
</script>
<style scoped>
.projeto-concluido-badge {
    margin-left: 0.75rem;
    font-size: 0.85rem;
    vertical-align: middle;
}

.bloco--pcm {
    background: transparent;
    box-shadow: none;
    overflow: visible;
}
</style>